import { render, staticRenderFns } from "./ApprovalListPagination.vue?vue&type=template&id=43fe05a5&scoped=true"
import script from "./ApprovalListPagination.vue?vue&type=script&lang=js"
export * from "./ApprovalListPagination.vue?vue&type=script&lang=js"
import style0 from "./ApprovalListPagination.vue?vue&type=style&index=0&id=43fe05a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fe05a5",
  null
  
)

export default component.exports